const API_BASE_URL = 'https://api.staging.onsolosocial.com';

export const getPricingPlans = async () => {
  const response = await fetch(API_BASE_URL+ "user/pricing-plans/");
  return response.json();
};

export const postToTikTok = async (postData) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/social/post/tiktok/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({
        video_url: postData.videoUrl,
        caption: postData.title,
        post_metadata: {
          social_account_id: postData.socialAccountId,
          privacy_level: postData.privacyLevel,
          allow_comment: postData.allowComment,
          allow_duet: postData.allowDuet,
          allow_stitch: postData.allowStitch,
          is_commercial_content: postData.isCommercialContent,
          is_branded_content: postData.isBrandedContent,
          is_your_brand: postData.isYourBrand
        }
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to post to TikTok');
    }

    const data = await response.json();
    return {
      success: data.success,
      postId: data.post_id,
      postUrl: data.post_url,
      message: data.message
    };
  } catch (error) {
    console.error('Error posting to TikTok:', error);
    throw error;
  }
};

export const getTikTokCreatorInfo = async (socialAccountId) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}connect/tiktok/creator-info/${socialAccountId}`, {
      headers: {
        'Authorization': `Token ${localStorage.getItem('token')}`,
      }
    });

    if (!response.ok) {
      throw new Error('Failed to fetch creator info');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching TikTok creator info:', error);
    throw error;
  }
};

export const checkTikTokPostStatus = async (postId) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/social/post/tiktok/status/${postId}`, {
      headers: {
        'Authorization': `Token ${localStorage.getItem('token')}`,
      }
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to check TikTok post status');
    }

    const data = await response.json();
    return {
      status: data.status, // 'PROCESSING', 'PUBLISHED', 'FAILED'
      message: data.message,
      postUrl: data.post_url
    };
  } catch (error) {
    console.error('Error checking TikTok post status:', error);
    throw error;
  }
};

// Content Buckets API Functions
export const getContentBuckets = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.is_active !== undefined) {
      queryParams.append('is_active', params.is_active);
    }
    if (params.industry_template) {
      queryParams.append('industry_template', params.industry_template);
    }
    if (params.search) {
      queryParams.append('search', params.search);
    }
    if (params.page) {
      queryParams.append('page', params.page);
    }
    if (params.page_size) {
      queryParams.append('page_size', params.page_size);
    }

    const url = `${process.env.REACT_APP_API_BASE_URL}/buckets/api/content-buckets/?${queryParams}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch content buckets');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching content buckets:', error);
    throw error;
  }
};

export const createContentBucket = async (bucketData) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/buckets/api/content-buckets/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(bucketData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to create content bucket');
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating content bucket:', error);
    throw error;
  }
};

export const updateContentBucket = async (bucketId, bucketData) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/buckets/api/content-buckets/${bucketId}/`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(bucketData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to update content bucket');
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating content bucket:', error);
    throw error;
  }
};

export const deleteContentBucket = async (bucketId) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/buckets/api/content-buckets/${bucketId}/`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to delete content bucket');
    }

    return { success: true };
  } catch (error) {
    console.error('Error deleting content bucket:', error);
    throw error;
  }
};

export const getIndustryTemplates = async () => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/buckets/api/content-buckets/industry-templates/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch industry templates');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching industry templates:', error);
    throw error;
  }
};

export const createBucketsFromTemplate = async (templateData) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/buckets/api/content-buckets/create-from-template/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(templateData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to create buckets from template');
    }

    return await response.json();
  } catch (error) {
    console.error('Error creating buckets from template:', error);
    throw error;
  }
};

export const getBucketContentIdeas = async (bucketId) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/buckets/api/content-buckets/${bucketId}/content-ideas/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch content ideas');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching content ideas:', error);
    throw error;
  }
};

export const getContentIdeas = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.industry_template) {
      queryParams.append('industry_template', params.industry_template);
    }
    if (params.bucket_name) {
      queryParams.append('bucket_name', params.bucket_name);
    }
    if (params.difficulty_level) {
      queryParams.append('difficulty_level', params.difficulty_level);
    }

    const url = `${process.env.REACT_APP_API_BASE_URL}/buckets/api/content-ideas/?${queryParams}`;
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch content ideas');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching content ideas:', error);
    throw error;
  }
};

export const assignPostToBucket = async (postId, bucketId) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/buckets/api/post-bucket-assignments/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({
        post: postId,
        bucket: bucketId,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to assign post to bucket');
    }

    return await response.json();
  } catch (error) {
    console.error('Error assigning post to bucket:', error);
    throw error;
  }
};

export const removePostFromBucket = async (assignmentId) => {
  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/buckets/api/post-bucket-assignments/${assignmentId}/`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to remove post from bucket');
    }

    return { success: true };
  } catch (error) {
    console.error('Error removing post from bucket:', error);
    throw error;
  }
};

// Optimized User Data API Functions
const API_BASE_URL_OPTIMIZED = `${process.env.REACT_APP_API_BASE_URL}api/optimized`;

/**
 * Debug function to check authentication and API configuration
 * @returns {Object} Debug information
 */
export const debugAuth = () => {
  const token = localStorage.getItem('token');
  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  const optimizedUrl = API_BASE_URL_OPTIMIZED;
  
  const debugInfo = {
    hasToken: !!token,
    tokenPrefix: token ? token.substring(0, 10) + '...' : 'undefined',
    baseUrl,
    optimizedUrl,
    fullStatsUrl: `${optimizedUrl}/user/stats/`,
    fullCalendarUrl: `${optimizedUrl}/user/calendar/`,
    fullProfileUrl: `${optimizedUrl}/user/profile/`,
  };
  
  console.log('Authentication Debug Info:', debugInfo);
  return debugInfo;
};

/**
 * Get user statistics for a specific month
 * @param {string} month - Optional month in YYYY-MM format
 * @returns {Promise} User statistics data
 */
export const getUserStats = async (month = null) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    const queryParams = month ? `?month=${month}` : '';
    const url = `${API_BASE_URL_OPTIMIZED}/user/stats/${queryParams}`;
    
    console.log('Fetching user stats from:', url);
    console.log('Using token:', token ? `${token.substring(0, 10)}...` : 'undefined');
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`,
      },
    });

    console.log('Stats response status:', response.status);

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Stats API error:', errorData);
      throw new Error(errorData.error || errorData.detail || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Stats data received:', data);
    return data;
  } catch (error) {
    console.error('Error fetching user stats:', error);
    throw error;
  }
};

/**
 * Get calendar events for a specific month
 * @param {string} month - Month in YYYY-MM format (required)
 * @returns {Promise} Calendar events data
 */
export const getCalendarEvents = async (month) => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    if (!month) {
      throw new Error('Month parameter is required for calendar events');
    }

    const url = `${API_BASE_URL_OPTIMIZED}/user/calendar/?month=${month}`;
    
    console.log('Fetching calendar events from:', url);
    console.log('Using token:', token ? `${token.substring(0, 10)}...` : 'undefined');
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`,
      },
    });

    console.log('Calendar response status:', response.status);

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Calendar API error:', errorData);
      throw new Error(errorData.error || errorData.detail || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Calendar data received:', data);
    return data;
  } catch (error) {
    console.error('Error fetching calendar events:', error);
    throw error;
  }
};

/**
 * Get user profile data
 * @returns {Promise} User profile data
 */
export const getUserProfile = async () => {
  try {
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('No authentication token found');
    }

    const url = `${API_BASE_URL_OPTIMIZED}/user/profile/`;
    
    console.log('Fetching user profile from:', url);
    console.log('Using token:', token ? `${token.substring(0, 10)}...` : 'undefined');
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${token}`,
      },
    });

    console.log('Profile response status:', response.status);

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Profile API error:', errorData);
      throw new Error(errorData.error || errorData.detail || `HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    console.log('Profile data received:', data);
    return data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
};

/**
 * Get complete user data (optimized version)
 * @param {string} month - Optional month in YYYY-MM format
 * @returns {Promise} Complete user data
 */
export const getUserDataOptimized = async (month = null) => {
  try {
    const queryParams = month ? `?month=${month}` : '';
    const url = `${API_BASE_URL_OPTIMIZED}/user/data/${queryParams}`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching optimized user data:', error);
    throw error;
  }
};

/**
 * Get legacy user data (backward compatibility)
 * @returns {Promise} Legacy user data format
 */
export const getUserDataLegacy = async () => {
  try {
    const url = `${API_BASE_URL_OPTIMIZED}/user/data/legacy/`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching legacy user data:', error);
    throw error;
  }
};

/**
 * Manage cache operations
 * @param {string} operation - Operation type: 'warm', 'invalidate', 'health'
 * @param {Array} cacheTypes - Optional array of cache types
 * @param {string} month - Optional month for cache operations
 * @returns {Promise} Cache operation result
 */
export const manageCaches = async (operation, cacheTypes = [], month = null) => {
  try {
    const url = `${API_BASE_URL_OPTIMIZED}/cache/manage/`;
    
    const requestBody = {
      operation,
      ...(cacheTypes.length > 0 && { cache_types: cacheTypes }),
      ...(month && { month }),
    };
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify(requestBody),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error managing caches:', error);
    throw error;
  }
};

/**
 * Check cache health
 * @returns {Promise} Cache health status
 */
export const getCacheHealth = async () => {
  try {
    const url = `${API_BASE_URL_OPTIMIZED}/cache/health/`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error checking cache health:', error);
    throw error;
  }
};

/**
 * Get performance metrics
 * @returns {Promise} Performance metrics data
 */
export const getPerformanceMetrics = async () => {
  try {
    const url = `${API_BASE_URL_OPTIMIZED}/performance/metrics/`;
    
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Token ${localStorage.getItem('token')}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching performance metrics:', error);
    throw error;
  }
};

/**
 * Helper function to format date for API calls
 * @param {Date} date - Date object
 * @returns {string} Formatted date string (YYYY-MM)
 */
export const formatMonthForAPI = (date = new Date()) => {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  return `${year}-${month}`;
};

/**
 * Helper function to validate month format
 * @param {string} month - Month string to validate
 * @returns {boolean} Whether the month format is valid
 */
export const isValidMonthFormat = (month) => {
  const monthRegex = /^\d{4}-(0[1-9]|1[0-2])$/;
  return monthRegex.test(month);
};